import { render } from "./NoProject.vue?vue&type=template&id=19de104d"
import script from "./NoProject.vue?vue&type=script&lang=js"
export * from "./NoProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__